<template>
  <router-link :to="{ name: 'RecipeDetails', params: { id: recipe.id } }">
    <div class="container">
      <div
        class="card-wrap"
        @mousemove="handleMouseMove"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        ref="card"
      >
        <div
          data-aos="zoom-in-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="1000"
          class="card"
          :style="cardStyle"
        >
          <div class="card-bg" :style="{ backgroundImage: 'url(' + recipe.coverUrl + ')' }"></div>
          <div class="card-info">
            <slot name="header"
              ><h1>{{ recipe.name }}</h1></slot
            >
            <slot name="content"
              ><p>{{ truncate(recipe.description, 120) }}</p></slot
            >
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  mounted() {
    this.width = this.$refs.card.offsetWidth;
    this.height = this.$refs.card.offsetHeight;
  },
  props: {
    recipe: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    width: 0,
    height: 0,
    mouseX: 0,
    mouseY: 0,
    mouseLeaveDelay: null,
  }),
  computed: {
    mousePX() {
      return this.mouseX / this.width;
    },
    mousePY() {
      return this.mouseY / this.height;
    },
    cardStyle() {
      const rX = this.mousePX * 30;
      const rY = this.mousePY * -30;
      return {
        transform: `rotateY(${rX}deg) rotateX(${rY}deg)`,
      };
    },
    cardBgTransform() {
      const tX = this.mousePX * -40;
      const tY = this.mousePY * -40;
      return {
        transform: `translateX(${tX}px) translateY(${tY}px)`,
      };
    },
    cardBgImage() {
      return {
        backgroundImage: `url(${this.dataImage})`,
      };
    },
  },
  methods: {
    handleMouseMove(e) {
      this.mouseX = e.pageX - this.$refs.card.offsetLeft - this.width / 2;
      this.mouseY = e.pageY - this.$refs.card.offsetTop - this.height / 2;
    },
    handleMouseEnter() {
      clearTimeout(this.mouseLeaveDelay);
    },
    handleMouseLeave() {
      this.mouseLeaveDelay = setTimeout(() => {
        this.mouseX = 0;
        this.mouseY = 0;
      }, 1000);
    },
    truncate(string, limit) {
      if (string.length > limit) {
        // eslint-disable-next-line no-param-reassign
        string = `${string.substr(0, limit)}...`;
      }
      return string;
    },
  },
};
</script>

<style lang="scss" scoped>
$hoverEasing: cubic-bezier(0.23, 1, 0.32, 1);
$returnEasing: cubic-bezier(0.445, 0.05, 0.55, 0.95);

$hoverEasing: cubic-bezier(0.23, 1, 0.32, 1);
$returnEasing: cubic-bezier(0.445, 0.05, 0.55, 0.95);

body {
  margin: 40px 0;
  font-family: 'Raleway';
  font-size: 14px;
  font-weight: 500;
  background-color: white !important;
  -webkit-font-smoothing: antialiased;
}

.title {
  font-family: 'Raleway';
  font-size: 24px;
  font-weight: 700;
  color: #5d4037;
  text-align: center;
}

.container {
  padding: 40px 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.card-wrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
  &:hover {
    .card-info {
      transform: translateY(0);
    }
    .card-info,
    .card-info p {
    }
    .card-info:after {
      transform: translateY(0);
    }
    .card-bg {
      transition: 0.6s $hoverEasing;
    }
    .card {
      transition: 0.6s $hoverEasing;
    }
  }
}

.card {
  position: relative;
  flex: 0 0 280px;
  width: 340px;
  background: white;
  height: 320px;
  z-index: 2;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: rgba(black, 0.66) 0 7px 15px 0,
    // inset #333 0 0 0 5px,
      inset rgba(white, 0.5) 0 0 0 6px;
  transition: 1s $returnEasing;
}

.card-bg {
  opacity: 1;
  position: absolute;
  top: -20px;
  left: -20px;
  width: 100%;
  height: 60%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s $returnEasing, opacity 5s 1s $returnEasing;
  pointer-events: none;
}

.card-info {
  padding: 25px 20px 10px 20px;
  position: absolute;
  z-index: 2;
  top: 60%;
  color: black;
  width: 340px;
  p {
    font-size: 0.9rem;
    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    line-height: 1.3em;
    width: 300px;
    height: 100px;
    // white-space: nowrap  !important;
    // overflow: hidden !important;
    // text-overflow: ellipsis!important;
  }

  * {
    position: relative;
    z-index: 1;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    // z-index: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, transparent 0%, rgba(#000, 0.6) 100%);
    background-blend-mode: overlay;
    opacity: 0;
    transform: translateY(100%);
    transition: 5s 1s $returnEasing;
  }
}

.card-info h1 {
  font-size: 1.3rem;
  font-weight: 700;
}
</style>
